/* eslint-disable import/no-cycle */
/* eslint react/no-array-index-key: 0 */
import cx from 'classnames';
// Locally importing moment seems to be tripping up translations. Global moment is configured and we can rely on that.
// import moment from 'moment';
import momentPropTypes from 'react-moment-proptypes';
import PropTypes from 'prop-types';
import React from 'react';

import { CalendarDay } from '.';
import { getCalendarMonthWeeks } from './utils';

import './CalendarMonth.scss';

function getWeekHeaders() {
  const currentMonth = moment();
  const firstDayOfWeek = moment.localeData().firstDayOfWeek();

  const weekHeaders = [];
  for (let i = 0; i < 7; i += 1) {
    weekHeaders.push(currentMonth.clone().day((i + firstDayOfWeek) % 7).format('dd'));
  }

  return weekHeaders;
}

export default function CalendarMonth({
  className,
  enableOutsideDays,
  month,
  renderDayContents,
}) {
  const handleKeydown = (e) => {
    const tabList = document.querySelectorAll('.ResyCalendar-day:not([disabled])');
    const domArray = Array.from(tabList);
    const tabIndex = domArray.indexOf(document.activeElement);

    if (e.key === 'ArrowLeft') {
      if (tabIndex !== 0) tabList[tabIndex - 1].focus();
    } else if (e.key === 'ArrowRight') {
      if (tabIndex !== (tabList.length - 1)) tabList[tabIndex + 1].focus();
    } else if (e.key === 'ArrowUp') {
      const currentCell = document.activeElement?.parentElement;
      const index = currentCell.cellIndex;
      const prev = currentCell.parentElement?.previousElementSibling?.cells[index];
      if (prev?.firstChild?.focus) {
        prev.firstChild.focus();
      }
    } else if (e.key === 'ArrowDown') {
      const currentCell = document.activeElement?.parentElement;
      const index = currentCell.cellIndex;
      const next = currentCell.parentElement?.nextElementSibling?.cells[index];
      if (next?.firstChild?.focus) {
        next.firstChild.focus();
      }
    }
  };

  const weeks = getCalendarMonthWeeks(
    month,
    enableOutsideDays,
    moment.localeData().firstDayOfWeek()
  );

  const monthTitle = month.format('MMMM YYYY');

  return (
    <div className={cx('CalendarMonth', className)}>
      {/* Note: disabling eslint errors for onKeyDown */}
      {/* eslint-disable */}
      <table role="table" onKeyDown={handleKeydown} className="CalendarMonth__Table">
      {/* eslint-enable */}
        <caption className="CalendarMonth__Title">{monthTitle}</caption>
        <thead>
          <tr role="row" className="CalendarMonth__Row">
            {
            getWeekHeaders()
              .map(
                (day) => (
                  <th
                    className="CalendarMonth__HeaderCell"
                    scope="col"
                    role="columnheader"
                    key={day}
                  >
                    {day}
                  </th>
                )
              )
          }
          </tr>
        </thead>
        <tbody>
          {weeks.map((week, i) => (
            <tr
              role="row"
              className="CalendarMonth__Row"
              key={`${monthTitle}_week_${i}`}
            >
              {week.map((day, index) => renderDayContents(
                { day, className: 'CalendarMonth__Cell', index }
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

CalendarMonth.propTypes = {
  className: PropTypes.string,
  enableOutsideDays: PropTypes.bool,
  month: momentPropTypes.momentObj,
  renderDayContents: PropTypes.func,
};

CalendarMonth.defaultProps = {
  className: undefined,
  enableOutsideDays: false,
  month: moment(),
  renderDayContents: (props) => (<CalendarDay {...props} />),
};
